import React from "react";
import Flex from "../../structure/Flex";
import Icon from "../Icon";

interface StatefulToggleButtonProps {
  toggled: any;
  setToggled: React.Dispatch<any>;
  onLabel?: string;
  offLabel?: string;
  className?: string;
  textSize?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  disabled?: true;
}

const StatefulToggleButton: React.FC<StatefulToggleButtonProps> = ({
  toggled,
  setToggled,
  onLabel = "",
  offLabel = "",
  className = "",
  disabled = undefined,
  textSize = "xs",
}) => {
  return (
    <Flex items="center" className="outline-none space-x-2">
      <span
        className={`${textSize} uppercase font-medium ${
          !toggled ? "text-gray-700" : "text-gray-500"
        }`}
      >
        {offLabel}
      </span>

      <button
        className="flex cursor-pointer disabled:cursor-not-allowed focus:outline-none"
        onClick={() => setToggled((t: any) => !t)}
        disabled={disabled}
      >
        <Icon className={`text-gray-700 text-4xl ${className}`}>
          {toggled ? "toggle_on" : "toggle_off"}
        </Icon>
      </button>

      <span
        className={`${textSize} uppercase font-medium ${
          toggled ? "text-gray-700" : "text-gray-500"
        }`}
      >
        {onLabel}
      </span>
    </Flex>
  );
};

export default StatefulToggleButton;
